module.exports = __webpack_public_path__ + "static/how-it-works-3-eea9dd95c2295e1ba6844d7f4e3599d2.png";